// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetConstructorsListRequest,
  TGetConstructorsListModel,
  IMappers,
  TGetConstructorsListResponse,
  IGetConstructorsListResponse,
  IGetConstructorsListResponseError,
} from './types';

export const defaultConfig: TGetConstructorsListModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'countryside-constructors',
  pathApi: '/v3/get-constructors-list/',
  requestType: 'json',
} as TGetConstructorsListModel;

export function createGetConstructorsListModel(parameters: IGetConstructorsListRequest): TGetConstructorsListModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetConstructorsListOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetConstructorsListRequest;
}

export async function fetchGetConstructorsList<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetConstructorsListOptions<TResponse200, TResponse400>): Promise<
  TGetConstructorsListResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetConstructorsListModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetConstructorsListResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetConstructorsListResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetConstructorsListResponse;
}
